module.exports = __webpack_public_path__ + "static/media/sale-green.473e48fa.svg";